import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { loadUserStatus } from '../actions';
import { Spin } from 'antd';
import { getUserFullName } from '../../../utils/common';
import UserStatusChart from './UserStatusChart';

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidUpdate(state) {
    const { users, match } = this.props;
    const allUsers = users && users.data;
    const userIdentifier = match.params.identifier;
    if (allUsers && allUsers.length) {
      const user = allUsers.find(u => u.identifier === userIdentifier);
      const currentUser = this.state.user || {};
      if (user && user.id && currentUser.id !== user.id) {
        this.setState({ user });
        this.props.loadUserStatus(user.id);
      }
    }
  }

  render() {
    const { user } = this.state;
    const { userStatus } = this.props;
    let currentUserStatus;
    if (user && user.id && userStatus) {
      currentUserStatus = userStatus[user.id];
    }
    return (
      <React.Fragment>
        <h1>User Status {user && `- ${getUserFullName(user)}`}</h1>
        {!user && <Spin size="large" />}
        {user && (
          <div>
            {!currentUserStatus && <Spin size="large" />}
            {currentUserStatus && (
              <UserStatusChart
                timestamps={currentUserStatus.activeTimestamps}
              />
            )}
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  userStatus: state.userStatus,
  users: state.users
});

function mapDispatchToProps(dispatch) {
  return {
    loadUserStatus: (userId, pageNum = 0) =>
      dispatch(loadUserStatus(userId, pageNum))
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Dashboard)
);



// WEBPACK FOOTER //
// ./src/modules/Users/Dashboard/index.js